import { useEffect } from 'react';
import type { Store } from '@/stores';

// constants
import { DEFAULT_SORTING_LOGIC } from '@tajawal/web-flights-sdk/lib/constants';

// custom hook to make search api call
// make an api call every time query changes
const useFetchSearchResults = (store: Store, query: string, isRoundTrip: boolean): void => {
  const pageStore = isRoundTrip ? store.appStore.stepByStepSearchPage.outbound : store.appStore.completeSearchPage;

  useEffect(() => {
    try {
      // @ts-ignore
      pageStore.searchResults.fetch({
        query,
        sortingLogic: DEFAULT_SORTING_LOGIC,
      });
    } catch (e) {
      // TODO: handle Error on UI
      console.error('SEARCH_RESULTS_FETCH_ERROR');
    }
  }, [query, isRoundTrip]);
};

export default useFetchSearchResults;
